import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export const HowWeHelp = () => {
  const { t, i18n } = useTranslation();

  // 表单字段状态管理
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [message, setMessage] = useState<string | null>(null); // 用于显示反馈信息

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // 阻止表单默认提交行为

    try {
      const response = await fetch("./send-email.php", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setMessage(t("howWeHelp.form.successMessage")); // 显示成功信息
        setFormData({ name: "", phone: "", email: "", message: "" }); // 清空表单字段
      } else {
        setMessage(t("howWeHelp.form.errorMessage")); // 显示失败信息
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      setMessage(t("howWeHelp.form.errorMessage")); // 显示失败信息
    }
  };

  const steps = [
    {
      number: "1",
      title: t("howWeHelp.step1.title"),
      content: t("howWeHelp.step1.content"),
    },
    {
      number: "2",
      title: t("howWeHelp.step2.title"),
      content: t("howWeHelp.step2.content"),
    },
    {
      number: "3",
      title: t("howWeHelp.step3.title"),
      content: t("howWeHelp.step3.content"),
    },
  ];

  return (
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16 text-[#bc943e]">
            {t("howWeHelp.title")}
          </h2>
          <div className="grid md:grid-cols-2 gap-16">
            <div className="space-y-12">
              {steps.map((step) => (
                  <div key={step.number} className="flex gap-6">
                    <div className="text-5xl font-bold text-[#F5A623] leading-none">
                      {step.number}.
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-4 text-[#333333]">
                        {step.title}
                      </h3>
                      <p className="text-[#666666] text-lg leading-relaxed">
                        {step.content}
                      </p>
                    </div>
                  </div>
              ))}
            </div>
            <div className="bg-[#F7F7F7] p-8 rounded-lg shadow-lg text-black">
              {/* 表单开始 */}
              <form onSubmit={handleSubmit} className="space-y-6">
                <h3 className="text-2xl font-bold mb-6 text-[#333333]">
                  {t("howWeHelp.form.title")}
                </h3>
                <Input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={t("howWeHelp.form.name")}
                    className="bg-white border-gray-300 h-12"
                    required
                />
                <Input
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={t("howWeHelp.form.phone")}
                    type="tel"
                    className="bg-white border-gray-300 h-12"
                    required
                />
                <Input
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t("howWeHelp.form.email")}
                    type="email"
                    className="bg-white border-gray-300 h-12"
                    required
                />
                <Textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t("howWeHelp.form.message")}
                    className="bg-white border-gray-300 min-h-[120px]"
                    required
                />
                <Button
                    type="submit"
                    className="w-full bg-[#F5A623] hover:bg-[#E69512] text-white h-12 text-lg"
                >
                  {t("howWeHelp.form.submit")}
                </Button>
              </form>
              {/* 显示反馈消息 */}
              {message && (
                  <div className="mt-4 text-center">
                    <p className="text-white bg-gray-800 p-2 rounded">{message}</p>
                  </div>
              )}
            </div>
          </div>
        </div>
      </section>
  );
};
